import { useState } from 'react';
import AdminOverridesData from './AdminOverridesData';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const INITIAL_ADMIN_OVERRIDES_STATE = {
  ...BASIC_INITIAL_STATE
};

const useAdminOverridesDataData = () => {
  const [adminOverridesState, setAdminOverrridesState] = useState(INITIAL_ADMIN_OVERRIDES_STATE);

  const putNewClubWorkflowOverride = (childOrgUnitId, parentOrgUnitId, offeringInstanceId) => {
    return AdminOverridesData.putNewClubWorkflowOverrideData(childOrgUnitId, parentOrgUnitId, offeringInstanceId, adminOverridesState, setAdminOverrridesState);
  };

  return {
    adminOverridesState,
    setAdminOverrridesState,
    putNewClubWorkflowOverride
  };
};

export default useAdminOverridesDataData;